module.exports = __webpack_public_path__ + "static/img/banner.72e32d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/banner.png
// module id = 5OQN
// module chunks = 41